import { pageModule } from '@components/pageModule';
import React from 'react';
import { AsyncPageRender } from '../../../Components/AsyncComponent';

export const routes$ = {
    Edit: AsyncPageRender(() => pageModule(import('./Edit'))),
    View: AsyncPageRender(() => pageModule(import('./View'))),
    List: AsyncPageRender(() => pageModule(import('./List'))),
    Finance: AsyncPageRender(() => pageModule(import('./Finance'))),
    Ledger: AsyncPageRender(() => pageModule(import('./Ledger'))),
};

function Router() {
    return (
        <>
            {/* <Route exact path={ '/salesmen' } component={ ProtectedRoute(routes$.List) }/>*/}
            {/* <Route exact path={ '/salesmen/:salesman' } component={ ProtectedRoute(routes$.View) }/>*/}
            {/* <Route exact path={ '/salesmen/:salesman/edit' } component={ ProtectedRoute(routes$.Edit) }/>*/}
            {/* <Route exact path={ '/salesmen/:salesman/order/:order' } component={ ProtectedRoute(order$.View) }/>*/}
            {/* <Route exact path={ '/salesmen-reports' } component={ ProtectedRoute(routes$.Finance) }/>*/}
        </>
    );
}

export default Router;
